import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { DataService } from './data.service';
@Injectable({
  providedIn: 'root',
})
export class UserAdminstrationService {
  baseUrl: string;
  constructor(private http: HttpClient, private dataService: DataService) {
    this.baseUrl = environment.baseUrl;
  }

  /**
   * Service for register the tanent of CM.
   * Created by Rashmi Ranjan
   * @Phantom
   * CreatedOn 03-Dec-2021
   */
  roleList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/list-role', payload);
  }

  changeRoleStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/status-role', payload);
  }

  addRole(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/add-role', payload);
  }

  updateRole(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/update-role', payload);
  }

  deleteRole(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/delete-role', payload);
  }

  menuList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/list-menu', payload);
  }

  changeMenuStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/status-menu', payload);
  }

  addMenu(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/add-menu', payload);
  }

  updateMenu(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/update-menu', payload);
  }

  deleteMenu(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/delete-menu', payload);
  }

  actionList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/list-action', payload);
  }

  changeActionStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/status-action', payload);
  }

  addAction(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/add-action', payload);
  }

  updateAction(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/update-action', payload);
  }

  deleteAction(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/delete-action', payload);
  }

  subMenuList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/list-sub-menu', payload);
  }

  changeSubMenuStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/status-sub-menu', payload);
  }

  addSubMenu(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/add-sub-menu', payload);
  }

  updateSubMenu(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/update-sub-menu', payload);
  }

  deleteSubMenu(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/delete-sub-menu', payload);
  }

  menuDropdownList(): Observable<any> {
    return this.http.get(this.baseUrl + 'privilege/menu-dropdown-list');
  }

  subMenuDropdownList(payload: any): Observable<any> {
    return this.http.get(
      this.baseUrl + 'privilege/sub-menu-dropdown-list?menu_id=' + payload
    );
  }

  assignActionList(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'privilege/list-assign-action',
      payload
    );
  }

  changeAssignActionStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'privilege/status-assign-action',
      payload
    );
  }

  addAssignAction(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'privilege/add-assign-action',
      payload
    );
  }

  updateAssignAction(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'privilege/update-assign-action',
      payload
    );
  }

  deleteAssignAction(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'privilege/delete-assign-action',
      payload
    );
  }

  actionDropdownList(): Observable<any> {
    return this.http.get(this.baseUrl + 'privilege/action-dropdown-list');
  }

  roleDropdownList(): Observable<any> {
    return this.http.get(this.baseUrl + 'privilege/role-dropdown-list');
  }

  rolePermission(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'privilege/role-permission', payload);
  }

  saveRolePermission(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'privilege/save-role-permission',
      payload
    );
  }

  uesrListData(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/list-users', payload);
  }

  uesrCountData(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/find-users', payload);
  }

  saveUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/add-user', payload);
  }

  updateUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-user', payload);
  }

  changeUserStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/change-status', payload);
  }

  getRoleData(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/role-data', payload);
  }

  aclPermission(payload: any): Observable<any> {
    this.dataService.menu.next([]);
    return this.http
      .post(this.baseUrl + 'privilege/acl-permission', payload)
      .pipe(
        map((res: any) => {
          if (res.status === 'success') {
            localStorage.setItem('aclDataTTCPMT', JSON.stringify(res.data));
            this.dataService.menu.next(res.data);
            localStorage.setItem(
              'permittedRoutesTTCPMT',
              JSON.stringify(res.permittedRoutes)
            );
          }
          return res;
        })
      );
  }
  saveClientUser(payload: any) {
    return this.http.post(this.baseUrl + 'user/save-client-user', payload);
  }
  getClientUsersDetails(clientId: string) {
    return this.http.get(
      this.baseUrl + `user/get-client-user-details/${clientId}`
    );
  }
  deleteClientUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-client-user', payload);
  }
  updateClientUserStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/update-client-User-status',
      payload
    );
  }
  bulkUpdateClientUser(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/bulk-update-client-user',
      payload
    );
  }
  updatePassword(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/update-client-user-password',
      payload
    );
  }
}
